module.exports = __webpack_public_path__ + "img/55.469289a4.gif";